import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import { customerDashboardActions } from "../../../../../../../redux/actions";
import SelectField from "../../../../../../../shared/components/Fields/SelectField";

const DownloadInvoice = ({ invoice, ...props }) => {
  const { groupEventId } = useParams();
  
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const handleDownloadInvoice = async () => {
    try {
      // Decode the base64 data to a Uint8Array
      const decodedData = atob(invoice);
      const dataArray = new Uint8Array(decodedData.length);
      for (let i = 0; i < decodedData.length; i++) {
        dataArray[i] = decodedData.charCodeAt(i);
      }

      // Create a Blob from the Uint8Array
      const blob = new Blob([dataArray], { type: "application/pdf" });

      // Create a Blob URL for the Blob
      const blobUrl = URL.createObjectURL(blob);

      // Create a link element to trigger the download
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "invoice.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the temporary URL
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  useEffect(() => {
    props.getInvoiceList(groupEventId);

    return () => {
      props.resetInvoiceList();
    }; // cleanup function
  }, []);

  useEffect(() => {
    setSelectedInvoice(
      props.invoiceList?.length ? props.invoiceList?.[0] : null
    );
  }, [props.invoiceList]);

  // function to handle the events dropdown
  const handleInvoiceSelect = (e) => {
    setSelectedInvoice(e);
  };

  useEffect(() => {
    if (selectedInvoice)
      props.generateInvoice(groupEventId, selectedInvoice.id);
    // eslint-disable-next-line
  }, [selectedInvoice]);

  useEffect(() => {
    // Decode the base64 data to a Uint8Array
    const decodedData = atob(invoice);
    const dataArray = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      dataArray[i] = decodedData.charCodeAt(i);
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([dataArray], { type: "application/pdf" });

    // Create a Blob URL for the Blob
    const blobUrl = URL.createObjectURL(blob);
    setPdfBlobUrl(blobUrl);

    // Clean up the temporary URL when the component unmounts
    return () => URL.revokeObjectURL(blobUrl);
  }, [invoice]);

  return (
    <div className="container px-0 col-12 mx-0">
      <h6>click here to download your invoice</h6>

      <div className="row d-flex align-item-center justify-content-between mb-3">
        <div className="col-12 col-sm-6 col-md-6 col-xl-4">
          {props.invoiceList?.length > 0 && (
            <SelectField
              options={props.invoiceList ?? []}
              id="select-invoice"
              placeholder="Select an Invoice"
              labelKey="invoiceNumber"
              valueKey="id"
              value={selectedInvoice}
              setValue={handleInvoiceSelect}
            />
          )}
        </div>
        <div className="col-12 col-sm-6 col-md-6 col-xl-8 mt-2 mt-sm-0">
          <button
            disabled={!invoice}
            className="gallery-btn m-0 float-right"
            onClick={handleDownloadInvoice}
          >
            Download Invoice
          </button>
        </div>
      </div>
      {invoice && pdfBlobUrl && (
        <iframe
          style={{ height: "140vh", width: "100%", display: "flex" }}
          title="PDF Viewer"
          src={pdfBlobUrl}
          type="application/pdf"
          width="100%"
          height="100%"
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  invoice: state.customerDashboard.invoice,
  invoiceList: state.customerDashboard.invoiceList,
});

const mapDispatchToProps = (dispatch) => ({
  getInvoiceList: (groupEventId) =>
    dispatch(customerDashboardActions.getInvoiceList(groupEventId)),
  resetInvoiceList: () => dispatch(customerDashboardActions.resetInvoiceList()),
  generateInvoice: (groupEventId, invoiceId) =>
    dispatch(customerDashboardActions.generateInvoice(groupEventId, invoiceId)),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(DownloadInvoice);
